// Etiquetas y colores de los 3 estados posibles de una conversacion de WhatsApp.
export const CONVERSATION_STATUS_LABELS = {
  bot: "Bot IA activo",
  escalated: "Escalada",
  resolved: "Resuelta",
};

export const CONVERSATION_STATUS_COLORS = {
  bot: "bg-[#E3EDE1] text-[#5B7A54]",
  escalated: "bg-[#F4E4D6] text-[#B5793A]",
  resolved: "bg-muted text-muted-foreground",
};

export function formatConversationTime(iso) {
  const date = new Date(iso);
  const now = new Date();
  const sameDay = date.toDateString() === now.toDateString();
  if (sameDay) return date.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  return date.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
}

// Fix AA (2026-10-15): un cliente con nombre de usuario de WhatsApp puede
// escribir sin que Meta mande su telefono; el chat queda guardado con su
// identificador de usuario, que no se muestra.
function usernameLabel(c) {
  return c.wa_username ? `@${String(c.wa_username).replace(/^@/, "")}` : "";
}

export function conversationTitle(c) {
  return c.patient_name || usernameLabel(c) || (String(c.patient_phone || "").startsWith("+") ? c.patient_phone : "Cliente de WhatsApp");
}

export function conversationContact(c) {
  const phone = String(c.patient_phone || "").startsWith("+") ? c.patient_phone : "Sin número visible";
  const user = usernameLabel(c);
  return user ? `${phone} · ${user}` : phone;
}

// Fix AD (2026-10-15): clasificacion comercial del chat. La etapa dice en que
// punto esta la conversacion (sin etapa = "Nuevo") y las etiquetas, acciones
// pendientes. Las claves son las mismas que valida el backend.
export const CONVERSATION_STAGES = [
  { key: "nuevo", label: "Nuevo" },
  { key: "en_conversacion", label: "En conversación" },
  { key: "informacion_brindada", label: "Información brindada" },
  { key: "seguimiento", label: "Seguimiento" },
  { key: "pendiente_reserva", label: "Pendiente de reserva" },
  { key: "cita_confirmada", label: "Cita confirmada" },
  { key: "servicio_realizado", label: "Servicio realizado" },
  { key: "cerrado_sin_venta", label: "Cerrado sin venta" },
];

export const CONVERSATION_STAGE_COLORS = {
  pendiente_reserva: "bg-[#F4E4D6] text-[#B5793A]",
  cita_confirmada: "bg-[#E3EDE1] text-[#5B7A54]",
  servicio_realizado: "bg-[#E3EDE1] text-[#5B7A54]",
  cerrado_sin_venta: "bg-muted text-muted-foreground",
};

export const CONVERSATION_TAGS = [
  { key: "seguimiento_1", label: "Seguimiento 1" },
  { key: "seguimiento_2", label: "Seguimiento 2" },
  { key: "seguimiento_3", label: "Seguimiento 3" },
  { key: "abandonado", label: "Abandonado" },
  { key: "pendiente_datos", label: "Pendiente de datos" },
  { key: "deposito_pendiente", label: "Depósito pendiente" },
  { key: "consulta_especialista", label: "Consulta especialista" },
  { key: "cliente_recurrente", label: "Cliente recurrente" },
  { key: "referido", label: "Referido" },
  { key: "reprogramar", label: "Reprogramar" },
];

// Fix AG (2026-10-21): las etapas las edita el equipo (GET /conversations/stages);
// CONVERSATION_STAGES queda como lista inicial mientras cargan.
export function stageLabel(key, stages = CONVERSATION_STAGES) {
  const k = key || "nuevo";
  return (stages.find((s) => s.key === k) || CONVERSATION_STAGES.find((s) => s.key === k) || { label: k }).label;
}

export function stageColor(key) {
  return CONVERSATION_STAGE_COLORS[key] || "bg-[#E6EEF5] text-[#3F6587]";
}

// Fix AE (2026-10-19): las etiquetas las edita el equipo (GET /conversations/tags);
// CONVERSATION_TAGS queda como lista inicial mientras cargan.
export function tagLabel(key, tags = CONVERSATION_TAGS) {
  return (tags.find((t) => t.key === key) || { label: key }).label;
}
